import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import  { Box } from '@mui/material';

import { exerciseOptions, fetchData, youtubeOptions } from '../utilities/fetchData';
import SimilarExercises from '../components/SimilarExercises';
import ExerciseVideos from '../components/ExerciseVideos';
import Detail from '../components/Detail';

function ExerciseDetail() {

  const [exerciseDetail, setExerciseDetail] = useState({});
  const [exerciseVideos, setExerciseVideos] = useState([]);
  const [targetMusleExercises, setTargetMusleExercises] = useState([]);
  const [equipmentExercises, setEquipmentExercises] = useState([]);


  const { id } = useParams();

  useEffect(() => {
    const fetchExercisesData = async () => {
      const exerciseDbUrl = 'https://exercisedb.p.rapidapi.com';

      const youtubeSearchUrl ='https://youtube-search-and-download.p.rapidapi.com';

      const exerciseDetailData = await fetchData(`${exerciseDbUrl}/exercises/exercise/${id}`, exerciseOptions);
      setExerciseDetail(exerciseDetailData);

      const exerciseVideosData = await fetchData(`${youtubeSearchUrl}/search?query=${exerciseDetailData.name}`, youtubeOptions);
      setExerciseVideos(exerciseVideosData.contents);

      const targetMuscleExercisesData = await fetchData(`${exerciseDbUrl}/exercises/target/${exerciseDetailData.target}`, exerciseOptions);
      setTargetMusleExercises(targetMuscleExercisesData);

      const equipmentsExercisesData  = await fetchData(`${exerciseDbUrl}/exercises/equipment/${exerciseDetailData.equipment}`, exerciseOptions);
      setEquipmentExercises(equipmentsExercisesData);
    }
    fetchExercisesData();
  }, [id])
  

  return (
    <Box>
      <Detail exerciseDetail={exerciseDetail} />
      <ExerciseVideos exerciseVideos={exerciseVideos} name={exerciseDetail.name}/>
      <SimilarExercises targetMusleExercises={targetMusleExercises} equipmentExercises={equipmentExercises} />
    </Box>
  )
}

export default ExerciseDetail